import {
  CatalogueGetArrivalDistrictsListParams,
  CatalogueGetAvailableAirlinesListParams,
  CatalogueGetFlightDateOptionsListParams,
  CatalogueGetHotelsListParams
} from '@appTypes/api.types';
import { SearchTourPackagesPaging } from '../tours.types';
import { TourRowCheck } from '../tours-row-checks.types';

export class toursReset {
  static readonly type = '[Tours] Reset';
}
export class toursGetAvailableAirlines {
  static readonly type = '[Tours] GetAvailableAirlines';
  constructor(
    public params?: CatalogueGetAvailableAirlinesListParams,
    public refresh = false
  ) {}
}

export class toursGetDestinationCountries {
  static readonly type = '[Tours] GetDestinationCountries';
  /**
   * DEST-017: `departureCityUID` narrows the offered destinations to what is sold from that departure city (package mode);
   * omit it for the unfiltered list (init, before a departure city is known).
   */
  constructor(
    public departureCityUID?: string,
    public refresh = false
  ) {}
}

export class toursGetArrivalDistricts {
  static readonly type = '[Tours] GetArrivalDistricts';
  constructor(
    public params: CatalogueGetArrivalDistrictsListParams,
    public refresh = false
  ) {}
}

export class toursGetHotels {
  static readonly type = '[Tours] GetHotels';
  constructor(
    public params: CatalogueGetHotelsListParams,
    public refresh = false
  ) {}
}
export class toursLoadFlightDateOptions {
  static readonly type = '[Tours] GetFlightDateOptions';
  constructor(
    public params: CatalogueGetFlightDateOptionsListParams,
    public identifier: string
  ) {}
}

export class toursSearchTourPackages {
  static readonly type = '[Tours] SearchTourPackages';
  /**
   * @param paging the page / sort / page size of a page request (none = a new search)
   * @param repeatOfExpired true for the one repeat of a search whose stored result expired (an answer said `SearchDataExpired`), so a second
   *   expiry does not repeat it again
   */
  constructor(
    public paging?: SearchTourPackagesPaging,
    public repeatOfExpired = false
  ) {}
}

/**
 * Progressive tour search (docs features/website/tour-search-progressive.md R-PT2, R-PT4, R-PT5): asks the running search (`ps-` pagingId) for its
 * current page after `delayMs`; the answer that completes it carries the classic paging id. Dispatching it again replaces the running poll.
 */
export class toursPollSearchProgress {
  static readonly type = '[Tours] PollSearchProgress';
  constructor(
    public pagingId: string,
    public delayMs: number,
    public failures = 0
  ) {}
}

/** The agent pressed a row's price: its Details are asked (CalcPackage) and the row shows `checking` until they answer. */
export class toursRowCheckStarted {
  static readonly type = '[Tours] RowCheckStarted';
  constructor(public key: string) {}
}

/** The first Details answer of a pressed row, as the row's check (confirmed, changed, unavailable, failed). */
export class toursRowCheckAnswered {
  static readonly type = '[Tours] RowCheckAnswered';
  constructor(
    public key: string,
    public check: TourRowCheck
  ) {}
}

/** R-P2-6 "Remove from list": the only way a row leaves the list. */
export class toursDismissTourRow {
  static readonly type = '[Tours] DismissTourRow';
  constructor(public key: string) {}
}

/** R-P2-6 "Show anyway": Details of an unavailable row are offered again. */
export class toursShowRowAnyway {
  static readonly type = '[Tours] ShowRowAnyway';
  constructor(public key: string) {}
}

export class toursSearchChildPackages {
  static readonly type = '[Tours] SearchChildPackages';
  constructor(
    public parentHotelCode: string,
    public reload = false
  ) {}
}
export class toursResetSearchResult {
  static readonly type = '[Tours] toursResetSearchResult';
}
